import CadrageBanner from "./CadrageBanner"
import CadrageForm from "./CadrageForm"

const Cadrage = () => {

    return(
        <>
            <div class="bg-light">
                <CadrageBanner />
                <div className="container py-5">
                    <div className="py-5">
                        <p className="page-title text-center">Information préalable :</p>
                        <p className="grey-text text-center">
                            En tant que négoce, nous ne nous substituons pas au maitre d’œuvre. Nous
                            ne réalisons pas les <br /> plans de permis de construire et ne faisons
                            pas de pose sur chantier.
                        </p>
                    </div>
                </div>
                <div className="container">
                    <CadrageForm />
                </div>
            </div>
        </>
    )

}

export default Cadrage